export default __webpack_public_path__ + "static/media/truck.4359a771.svg";